import { render } from "./AudioFadeTab.vue?vue&type=template&id=03ca731b"
import script from "./AudioFadeTab.vue?vue&type=script&lang=js"
export * from "./AudioFadeTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__